import _ from 'lodash';
import moment from 'moment';
import {
  fetchNotifications,
  readNotifications,
  unreadNotificationsCount,
} from '@/api/notifications';
import { ADMIN_PERMISSIONS, canAccess } from '@/access/adminAccess';
import {
  SET_NOTIFICATIONS,
  SET_UNREAD_COUNT,
  MARK_AS_READ,
} from './mutation-types';

export default {
  state: {
    data: [],
    unread: null,
    completed: false,
  },
  actions: {
    ACT_UPDATE_UNREAD_COUNT: async ({ commit, rootState }) => {
      if (!canAccess(rootState.auth.user, ADMIN_PERMISSIONS.ORDERS)) return Promise.resolve();
      return unreadNotificationsCount().then((response) => {
        if (response.data) {
          commit(SET_UNREAD_COUNT, response.data);
        }
        return response;
      });
    },
    ACT_FETCH_NOTIFICATIONS: async ({
      commit,
      dispatch,
      rootGetters: getters,
      state,
      rootState,
    }, { withRef = true }) => {
      if (!canAccess(rootState.auth.user, ADMIN_PERMISSIONS.ORDERS)) return Promise.resolve(true);
      if (getters['wait/is']('fetch.notifications')) {
        return Promise.reject();
      }
      dispatch('wait/start', 'fetch.notifications', { root: true });
      let referenceId = null;
      if (withRef) {
        if (state.data.length) {
          const last = _.last(state.data);
          referenceId = _.get(last, 'id') || null;
        }
      }
      const offset = -50;
      dispatch('ACT_UPDATE_UNREAD_COUNT');
      return fetchNotifications({
        offset,
        referenceId,
      }).then((response) => {
        const { length } = response.data;
        const completed = length < Math.abs(offset);
        if (response.data) {
          commit(SET_NOTIFICATIONS, {
            data: response.data,
            completed,
          });
        }
        return Promise.resolve(completed);
      }).finally(() => {
        dispatch('wait/end', 'fetch.notifications', { root: true });
      });
    },
    ACT_READ_NOTIFICATION: async ({
      commit,
      dispatch,
      state,
      rootState,
    }, id) => {
      if (!canAccess(rootState.auth.user, ADMIN_PERMISSIONS.ORDERS)) return Promise.resolve();
      if (!state.unread) {
        return Promise.resolve();
      }
      let data = id;
      if (typeof data === 'number' || typeof data === 'string') {
        data = [data];
      }
      commit(MARK_AS_READ, data);
      return readNotifications({
        read: data,
      }).then(() => {
        dispatch('ACT_UPDATE_UNREAD_COUNT');
      });
    },
  },
  mutations: {
    [SET_NOTIFICATIONS](state, {
      data,
      completed,
    }) {
      state.data = _(state.data)
        .unionBy(data, (obj) => obj.createdAt)
        .orderBy((obj) => moment(obj.createdAt).unix(), ['desc'])
        .value();
      state.completed = completed;
    },
    [SET_UNREAD_COUNT](state, { count }) {
      state.unread = count;
    },
    [MARK_AS_READ](state, id) {
      state.data = state.data.map((obj) => {
        if (id === null || id.includes(obj.id)) {
          return {
            ...obj,
            read: true,
          };
        }
        return obj;
      });
    },
  },
  namespaced: true,
};
